import React from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { Form, FieldWrapper } from "components/shared/form";
import { Row, Col } from "components/shared/layout";
import Input from "components/input";
import Button from "components/button";
import { navigate, Link } from "@reach/router";
import routes from "utils/absoluteRoutes";
import { isLocalHost } from "utils/environment";


const FRONTEND_URL = 'https://biz.zlto.co'
const FRONTEND_URL_TEST = 'http://localhost:3000'


const LoginForm = () => (
  <Formik
    initialValues={{ email: "", password: "" }}
    validationSchema={yup.object().shape({
      email: yup.string().email().required("Required").label("Email"),
      password: yup.string().required("Required").label("Password"),
    })}
    onSubmit={async (values, actions) => {
      navigate(routes.auth.signIn, { state: { ...values } });
      actions.setSubmitting(false);
    }}
    validateOnBlur
    validateOnChange
  >
    {({ handleSubmit, ...props }) => (
      <Form onSubmit={handleSubmit}>
        {/* <Row alignItems="flex-start">
          <Col xs={12}>
            <FieldWrapper>
              <Input type="text" name="email" placeholder="Email" />
            </FieldWrapper>
          </Col>
          <Col xs={12}>
            <FieldWrapper>
              <Input type="password" name="password" placeholder="Password" />
            </FieldWrapper>
          </Col>
        </Row> */}
          <Button
            variant='zltoLightBlue'
            type="submit"
            disabled={
              props.isSubmitting
            }
            onClick={() => window.location = `https://api.zlto.co/oauth/authorize?response_type=token&client_id=X4T7hkNHro3B1zSxc7IdfP4n9dC3cqjWRjyCMJoF&redirect_uri=${FRONTEND_URL}/auth/sign-in&scope=partner client store earn`}
          >
              Log in
          </Button>
      </Form>
    )}
  </Formik>
);

export default LoginForm;
